<div class="wrapper wrapper-content animated fadeInRight reports-workspace">
  <div class="row">
    <div class="col-lg-4">
      <div class="ibox">
        <div class="ibox-title">
          <h5>Report Catalog</h5>
        </div>
        <div class="ibox-content">
          @if (helpText) {
            <p class="text-muted small">{{ helpText }}</p>
          }

          @if (error()) {
            <div class="alert alert-danger">
              <i class="fa fa-warning m-r-xs"></i>{{ error() }}
            </div>
          }

          @if (loading()) {
            <div
              class="text-center m-t-md m-b-md"
              >
              <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
              <p class="text-muted m-t-sm">Loading report catalog…</p>
            </div>
          } @else {
            <div class="form-group">
              <label for="category-select" class="font-bold">Category</label>
              <select
                id="category-select"
                class="form-control"
                [value]="selectedCategoryId()"
                (change)="handleCategoryChange($event)"
                >
                @for (category of categories(); track category) {
                  <option
                    [value]="category.reportCategoryId"
                    >
                    {{ category.name }}
                  </option>
                }
              </select>
            </div>
            @if (reportsForSelectedCategory().length > 0) {
              <div
                class="list-group report-list"
                >
                @for (report of reportsForSelectedCategory(); track report) {
                  <button
                    type="button"
                    class="list-group-item list-group-item-action"
                    [class.active]="report.reportId === selectedReportId()"
                    (click)="selectReport(report.reportId)"
                    >
                    <span class="report-name">{{ report.name }}</span>
                  </button>
                }
              </div>
            } @else {
              <div class="alert alert-info m-b-none">
                <i class="fa fa-info-circle m-r-xs"></i>
                No reports available for this category.
              </div>
            }
          }

        </div>
      </div>
    </div>

    <div class="col-lg-8">
      <div class="ibox">
        <div class="ibox-title">
          <h5>{{ selectedReport()?.name || "Report Details" }}</h5>
        </div>
        <div class="ibox-content">
          @if (selectedReport()) {
            @if (hasContextSelectors) {
              <form
                class="m-t"
                [formGroup]="contextForm"
                >
                <div class="row">
                  @if ((roundOptions?.length || 0) > 0) {
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="font-bold">Round</label>
                        <select class="form-control" formControlName="roundId">
                          @for (option of roundOptions || []; track option) {
                            <option
                              [value]="option.id"
                              >
                              {{ option.label }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                  @if ((courseOptions?.length || 0) > 0) {
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="font-bold">Course</label>
                        <select class="form-control" formControlName="courseId">
                          @for (option of courseOptions || []; track option) {
                            <option
                              [value]="option.id"
                              >
                              {{ option.label }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                </div>
              </form>
            }
            @if (showHoleNumberParameter()) {
              <div class="parameter-options">
                <h5 class="text-muted text-uppercase font-bold">Parameters</h5>
                <div class="row">
                  <div class="col-sm-6 col-md-4">
                    <div class="form-group">
                      <label class="font-bold" for="hole-number-select"
                        >Hole Number</label
                        >
                        <select
                          id="hole-number-select"
                          class="form-control"
                          [value]="selectedHoleNumber()"
                          (change)="handleHoleNumberChange($event)"
                          >
                          @for (hole of holeNumberOptions; track hole) {
                            <option
                              [value]="hole"
                              >
                              {{ hole }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (showAGroupParameters()) {
                <div class="a-group-options">
                  <h5 class="text-muted text-uppercase font-bold">Options</h5>
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group m-b-none">
                        <label class="font-bold">Sort By</label>
                        @for (option of aGroupSortOptions; track option) {
                          <div class="radio">
                            <label>
                              <input
                                type="radio"
                                name="aGroupSort"
                                [value]="option.value"
                                [checked]="selectedAGroupSort() === option.value"
                                (change)="handleAGroupSortChange(option.value)"
                                />
                                {{ option.label }}
                              </label>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="checkbox m-t-lg">
                          <label>
                            <input
                              type="checkbox"
                              [checked]="showAGroupRank()"
                              (change)="handleAGroupShowRankChange($event)"
                              />
                              Show Rank
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="row m-t">
                    <div class="col-sm-6 col-md-4">
                      <div class="form-group">
                        <label for="format-select" class="font-bold">Format</label>
                        <select
                          id="format-select"
                          class="form-control"
                          [value]="selectedFormat()"
                          (change)="handleFormatChange($event)"
                          >
                          @for (option of formatOptions; track option) {
                            <option
                              [value]="option"
                              >
                              {{ option }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary m-t"
                    (click)="runReport()"
                    [disabled]="isExecuting()"
                    >
                    @if (isExecuting()) {
                      <i class="fa fa-spinner fa-spin m-r-xs"></i> Running…
                    } @else {
                      Run Report
                    }
                  </button>
                } @else {
                  <div class="alert alert-info m-b-none">
                    <i class="fa fa-info-circle m-r-xs"></i>
                    Select a report to view its details.
                  </div>
                }

              </div>
            </div>
          </div>
        </div>
      </div>
